import React from "react";
import { FaTimes } from "react-icons/fa";

const displayRideId = (row) => {
  if (row?.rideRequestId) return String(row.rideRequestId);
  if (row?.rideId) return String(row.rideId);
  return "N/A";
};

const formatDatePart = (value) => {
  if (!value) return "—";
  return new Date(value).toLocaleDateString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const formatTimePart = (value) => {
  if (!value) return "—";
  return new Date(value).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

const resolveSubject = (subject, customer) => {
  if (subject?.name) {
    return subject;
  }
  if (customer) {
    return {
      name: customer.customerName || customer.driverName || "N/A",
      mobile: customer.mobileNumber || "N/A",
    };
  }
  return null;
};

const CancellationTimingsModal = ({
  show,
  onClose,
  subject,
  customer,
  cancellations,
  loading,
  onRideClick,
  emptyMessage = "No user-cancelled rides found.",
}) => {
  if (!show) return null;

  const resolvedSubject = resolveSubject(subject, customer);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Cancellation timings</h3>
            {resolvedSubject && (
              <p className="text-sm text-gray-600 mt-1">
                {resolvedSubject.name} · {resolvedSubject.mobile}
              </p>
            )}
            {!loading && cancellations.length > 0 && (
              <p className="text-xs text-gray-500 mt-1">
                Showing last 3 cancellations (most recent first)
              </p>
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </div>

        <div className="overflow-y-auto flex-1 px-6 py-4">
          {loading ? (
            <p className="text-sm text-gray-500">Loading cancellations...</p>
          ) : cancellations.length === 0 ? (
            <p className="text-sm text-gray-500">{emptyMessage}</p>
          ) : (
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                    Ride ID
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                    Date
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                    Time
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {cancellations.map((row) => {
                  const when = row.cancelledAt || row.createdAt;
                  return (
                    <tr key={String(row.rideId)}>
                      <td className="px-4 py-3 text-sm">
                        <button
                          type="button"
                          onClick={() => onRideClick(row.rideId)}
                          className="font-mono text-blue-600 hover:text-blue-800 hover:underline"
                        >
                          {displayRideId(row)}
                        </button>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {formatDatePart(when)}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {formatTimePart(when)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default CancellationTimingsModal;
